import { useState } from "react";
import { Modal, Dropdown } from "semantic-ui-react";

import { ModalContactTable } from "components/modals/modal_contact_table/ModalContactTable";

const IncludeContactsModal = ({ entityId, campaignId, onSuccess }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Modal
      size="large"
      trigger={<Dropdown.Item>Include Contacts</Dropdown.Item>}
      closeIcon
      open={modalOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      closeOnDimmerClick={false}
    >
      <Modal.Header>Include Contacts</Modal.Header>
      <Modal.Content>
        <div className="tw:flex tw:h-[80vh] tw:w-full tw:flex-col tw:overflow-y-auto">
          <ModalContactTable
            entityId={entityId}
            campaignId={campaignId}
            onSuccess={onSuccess}
            enableSearch
          />
        </div>
      </Modal.Content>
    </Modal>
  );
};

export { IncludeContactsModal };
